import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [lang, setLang] = useState(() => localStorage.getItem("eigoo_lang") || "en");
  const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("eigoo_token");
    if (!token) {
      setLoadingAuth(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("eigoo_token"))
      .finally(() => setLoadingAuth(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("eigoo_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("eigoo_token");
    setUser(null);
    window.location.href = "/login";
  }, []);

  const changeLang = useCallback((next) => {
    setLang(next);
    localStorage.setItem("eigoo_lang", next);
  }, []);

  return (
    <AppCtx.Provider value={{ user, lang, setLang: changeLang, login, logout, loadingAuth }}>
      {children}
    </AppCtx.Provider>
  );
}

export const useApp = () => useContext(AppCtx);
